import { ReactComponent as CoinsBambooLogoMedium } from "./logo-medium.svg";

const LogoMedium: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = ({ style, ...props }) => (
  <CoinsBambooLogoMedium
    {...props}
    style={{
      display: "block",
      width: "70px",
      maxWidth: "100%",
      height: "auto",
      ...style,
    }}
  />
);

export default LogoMedium;
